import { FC } from 'react'

import { FF, FormType, RadioGroup, Select, TextareaInput } from 'ui/components'
import { Col, Col2x, FormRow } from 'ui/themes/globalStyles'

import { QuestionnaireDemo } from '../../../../../../types'
import * as SC from '../../../../style'

export const DepositActivity: FC<{ formApi: FormType<QuestionnaireDemo> }> = ({ formApi }) => {
  return (
    <>
      <FormRow>
        <Col>
          <SC.SecondText>
            A marijuana-related business engages in international or interstate activity, including by receiving cash
            deposits from locations outside the state in which the business operates,making or receiving frequent or
            large interstate transfers, or otherwise transacting with persons or entities located in different states or
            countries.
          </SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="mrbOutsideStateActivity"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col2x>
          <SC.SecondText>
            Review the account activity for suspicious out-of-state deposits.
            <br />
            Review wire activity for suspicious transactions not originated in legalized states.
            <br />
            Review wire activity for suspicious international transactions.
            <br />
            Review the International ACH information for suspicious activity.
            <br />
            Review POS activity for suspicious international transactions.
          </SC.SecondText>
        </Col2x>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>
            A surge in activity by third parties offering goods or services to marijuana-related business, such as
            equipment suppliers or shipping servicers.
          </SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="mrbSurgeThirdParties"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>
            Review all ACH transactions for suspicious unknown merchant ACH activity. Internet research is performed to
            determine if the merchant is possibly an equipment supplier or shipping servicer.
          </SC.SecondText>
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>
            The business is unable to demonstrate the legitimate source of significant outside investments.
          </SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="legitimateOutsideInvestmentsUnable"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>
            Review Wire, ACH and Deposit activity, if the source of funds from an outside investor is suspicious, an
            explanation will be required from the customer and escalated to management
          </SC.SecondText>
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>Review account activity</SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="accountActivityReview"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>Review all Deposit activity for out-of-state checks</SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="depositActivityOutsideChecksReview"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <formApi.Field
            name="depositActivityOutsideChecksDeposited"
            children={(field) => (
              <FF
                field={field}
                label="Were there out-of-state checks deposited?"
                input={(p) => (
                  <Select
                    data={[
                      {
                        label: 'Yes – See comments',
                        value: 'yes'
                      },
                      {
                        label: 'All Transactions Ok',
                        value: 'all_transactions'
                      },
                      {
                        label: 'No Transactions of this Type',
                        value: 'no_transactions'
                      }
                    ]}
                    {...p}
                  />
                )}
              />
            )}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <formApi.Field
            name="depositActivityOutsideChecksAddressed"
            children={(field) => (
              <FF
                field={field}
                label="If noted, how was the activity addressed?"
                input={(p) => (
                  <Select
                    data={[
                      {
                        label: 'N/A',
                        value: 'n/a'
                      },
                      {
                        label: 'Transaction cleared with communication to customer during review',
                        value: 'cleared'
                      },
                      {
                        label: 'Transaction added to Annual Review questions',
                        value: 'added'
                      }
                    ]}
                    {...p}
                  />
                )}
              />
            )}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col2x>
          <formApi.Field
            name="depositActivityOutsideChecksComments"
            children={(field) => (
              <FF field={field} label="Comments" input={(p) => <TextareaInput maxLength={5000} {...p} />} />
            )}
          />
        </Col2x>
      </FormRow>
    </>
  )
}
